import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { WelcomeDialogComponent } from './welcome-dialog/welcome-dialog.component';
import { AgentProfileService } from '../../shared/services/agent-profile.service';
@Component({
  selector: 'app-welcome-popup',
  templateUrl: './welcome-popup.component.html',
  styleUrls: ['./welcome-popup.component.scss'],
})
export class WelcomePopupComponent implements OnInit {
  @Input() agentInfo;
  @Input() agentAgencyName;
  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private agentInfoService: AgentProfileService,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      const welcomeDialogRef = this.dialog.open(WelcomeDialogComponent, {
        width: '420px',
        panelClass: 'welcome-dialog-panel',
        data: {
          agentInfo: this.agentInfo,
          agentAgencyName: this.agentAgencyName,
        },
        disableClose: true,
      });
    });
  }
}
